import { render, staticRenderFns } from "./uploadfileblock.vue?vue&type=template&id=12a287bc"
import script from "./uploadfileblock.vue?vue&type=script&lang=ts"
export * from "./uploadfileblock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports